/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    MSStream: any;
  }
}

import { Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Admin from './pages/Admin';
import { useProfile } from './hooks/useProfile';
import Employees from './pages/Admin/Employees';
import { RoleProvider } from './contexts/RoleContext';
import Customers from './pages/Admin/Customers';
import LoadingComponent from './components/LoadingComponent';
import { useProfileContext } from './hooks/useProfileContext';
import { useEffect } from 'react';
import ManageOrders from './pages/Admin/ManageOrders';
import ManageGiftRequests from './pages/Admin/ManageGiftRequests';
import NotFound from './pages/NotFound';
import ManageSuppliers from './pages/Admin/ManageSuppliers';
import ManageGifts from './pages/Admin/ManageGifts';
import ManageRoles from './pages/Admin/ManageRoles';
import ChangePassword from './pages/Admin/ChangePassword';
import CrawlFb from './pages/Admin/CrawlFb';
import ListCrawFb from './pages/Admin/ListCrawFb';
import Dashboard from './pages/Admin/Dashboard';
function App() {
  const { data: profile, isLoading } = useProfile();
  const { setProfile } = useProfileContext();

  useEffect(() => {
    if (profile) {
      setProfile(profile);
    }
  }, [profile, setProfile]);

  return (
    <RoleProvider>
      <>
        {isLoading ? (
          <div className="flex items-center justify-center h-screen">
            <LoadingComponent />
          </div>
        ) : (
          <div className="flex flex-col min-h-screen">
            <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable
              pauseOnHover
              theme="light"
              style={{
                fontSize: '14px',
                fontWeight: 500,
              }}
              toastStyle={{
                maxWidth: '350px',
                minHeight: '60px',
                margin: '12px',
                padding: '16px',
                borderRadius: '8px',
                boxShadow: '0 8px 16px rgba(0,0,0,0.12)',
                backgroundColor: '#ffffff',
                color: '#333333',
                border: '1px solid rgba(0,0,0,0.05)',
                overflow: 'hidden',
              }}
            />

            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              >
                <Route path="manage-employees" element={<Employees />} />
                <Route path="manage-customers" element={<Customers />} />
                <Route path="manage-gifts" element={<ManageGifts />} />
                <Route
                  path="manage-gift-requests"
                  element={<ManageGiftRequests />}
                />
                <Route path="manage-orders" element={<ManageOrders />} />
                <Route path="manage-suppliers" element={<ManageSuppliers />} />
                <Route path="manage-roles" element={<ManageRoles />} />
                <Route path="change-password" element={<ChangePassword />} />
                <Route path="crawl-fb" element={<CrawlFb />} />
                <Route path="list-crawl-fb" element={<ListCrawFb />} />
                <Route path="dashboard" element={<Dashboard />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        )}
      </>
    </RoleProvider>
  );
}

export default App;
